export default __webpack_public_path__ + "static/media/vn.7092fa6d.svg";